<template>
  <div class="header-info">
   
  </div>
</template>
<script>
import config from '@/config'
import store from '@/store'
import Icon from '@/components/common/Icon'
import Screen from '@/components/mixins/Screen'
import Time from '@/components/mixins/Time'

export default {
  name: 'HeaderInfo',

  mixins: [Screen, Time],

  components: {
    Icon
  },

  data: () => ({
    sessionTime: 0
  }),

  computed: {
    externalUrls () { return config.externalUrls },
    dateFormats () { return config.app.dateFormats },
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    sessionDetails () {
      return store.getters['getSessionDetails']
    },
    lastLogin () {
      let sessionDetailsCookie = config.customCookies.getCookie('sessionDetails')
      let lastLoginStr = ''

      if (this.sessionDetails && this.sessionDetails.lastlogin) {
        lastLoginStr = this.dateToLocaleDatetimeString(new Date(this.sessionDetails.lastlogin), this.dateFormats.longDateTime)
      } else if (sessionDetailsCookie && sessionDetailsCookie.lastlogin) {
        lastLoginStr = this.dateToLocaleDatetimeString(new Date(sessionDetailsCookie.lastlogin), this.dateFormats.longDateTime)
      }

      return lastLoginStr
    },
    personalDetails () {
      return store.getters['getPersonalDetails']
    }
  },
  methods: {},

  created () {
    setInterval(() => {
      let value = Math.round(Math.abs(localStorage.loginTime - Date.now()) / 1000)
      if (value >= 0) {
        let minutes = Math.floor(value / 60)
        let seconds = value - minutes * 60
        seconds = (seconds < 10 ? ('0' + seconds) : seconds)
        minutes = (minutes < 10 ? ('0' + minutes) : minutes)
        this.sessionTime = `${minutes}:${seconds}`
      }
    }, 1000)
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/css/config"
.float-right span
.float-right
  text-align: right

.float-right div
  float: right

.float-left span 
  float: left

.header-info 
  font-weight: normal
  font-size: 10px
  padding: 0 8px

.header-txt
  line-height: 20px

</style>



// WEBPACK FOOTER //
// src/components/common/HeaderInfo.vue